// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8bf1765d","498":"66e7a938","703":"fc6be2c1"}[chunkId] + ".chunk.js";
};